import { isMatch } from 'lodash';
import arrayIsEmpty from 'src/utils/arrayOperations/arrayIsEmpty';
import getCurrentRecord from 'src/utils/entityOperations/getCurrentRecord';
import getRecordByRecordId from 'src/utils/entityOperations/getRecordByRecordId';
import setCurrentRecord from 'src/utils/entityOperations/setCurrentRecord';
import { error } from 'src/utils/notification/NotificationService';
import { getParentsOfChild } from './parentChildRel/getParentsOfChild';
// region: Accessors
export function setCurrentApplicationEntityModel(model) {
    const appObj = getCurrentRecord('apps.apps');
    const newAppObj = Object.assign(Object.assign(Object.assign({}, appObj), getCurrentApplicationEntityModel()), { applicationEntityModel: model });
    setCurrentRecord('apps.apps', newAppObj);
}
export function getCurrentApplicationEntityModel() {
    const appObj = getCurrentRecord('apps.apps');
    if (!appObj)
        return undefined;
    return appObj === null || appObj === void 0 ? void 0 : appObj.applicationEntityModel;
}
export function getParentChildRelsOfParentEntity(parentEntityName) {
    const model = getCurrentApplicationEntityModel();
    if (!model)
        return [];
    return model.parentChildRelations.filter(rel => rel.entities.parent === parentEntityName);
}
export function getParentChildRelsOfChildEntity(childEntityName) {
    const model = getCurrentApplicationEntityModel();
    if (!model)
        return [];
    return model.parentChildRelations.filter(rel => rel.entities.children.includes(childEntityName));
}
export function getParentChildRelOfParentEntityAndChildEntity(parentEntityName, childEntityName) {
    const model = getCurrentApplicationEntityModel();
    if (!model) {
        error('Application entity model not available at this time');
        return;
    }
    return model.parentChildRelations.find(rel => rel.entities.parent === parentEntityName && rel.entities.children.includes(childEntityName));
}
// endregion
// region: ParentChildRel getters
export function getMatchingParentChildRels(partialParentChildRel) {
    const model = getCurrentApplicationEntityModel();
    if (!model)
        return [];
    return model.parentChildRelations.filter(rel => isMatch(rel, partialParentChildRel));
}
export function getParentChildRelsOfChildRecord(childRecord) {
    const model = getCurrentApplicationEntityModel();
    if (!model)
        return [];
    return getMatchingParentChildRels({ entities: { children: childRecord.entityName } });
}
export function getAncestorParentChildRelsOfChildRecord(childRecord) {
    const model = getCurrentApplicationEntityModel();
    if (!model)
        return [];
    const acc = [];
    const rels = getParentChildRelsOfChildRecord(childRecord);
    if (arrayIsEmpty(rels))
        return acc;
    else {
        acc.push(...rels);
        rels.forEach(rel => {
            const parentRecord = getCurrentRecord(rel.entities.parent);
            if (parentRecord && parentRecord.id) {
                const parentRels = getAncestorParentChildRelsOfChildRecord({ entityName: rel.entities.parent, id: parentRecord.id });
                acc.push(...parentRels);
            }
        });
    }
    return acc;
}
export function getAncestorRecordsOfChildRecord(childRecord) {
    const acc = [];
    const parentRecords = getParentsOfChild(childRecord);
    if (arrayIsEmpty(parentRecords))
        return acc;
    else {
        acc.push(...parentRecords);
        parentRecords.forEach(parentRecord => {
            acc.push(...getAncestorRecordsOfChildRecord(parentRecord));
        });
    }
    return acc;
}
export function getSelfAndAncestors(recordId) {
    const record = getRecordByRecordId(recordId);
    const ancestorRecords = getAncestorRecordsOfChildRecord(record);
    return [record, ...ancestorRecords];
}
export function getChildrenEntityNamesOfEntity(entityName) {
    const model = getCurrentApplicationEntityModel();
    if (!model)
        return [];
    return model.parentChildRelations.filter(rel => rel.entities.parent === entityName).map(rel => rel.entities.children);
}
// endregion
export function getAncestorEntityChain(entityName) {
    const model = getCurrentApplicationEntityModel();
    if (!model)
        return [];
    const acc = [];
    const parentChildRels = getParentChildRelsOfChildEntity(entityName);
    if (arrayIsEmpty(parentChildRels))
        return [];
    else {
        parentChildRels.forEach(rel => {
            acc.push({
                left: rel.entities.parent,
                right: entityName,
                relationType: '1:m'
            });
            const ancestorChain = getAncestorEntityChain(rel.entities.parent);
            if (ancestorChain)
                acc.push(...ancestorChain);
        });
    }
    return acc;
}
